import React, { useEffect } from 'react'
import styles from "./styles";
import { CRYPTOJS_IV, CRYPTOJS_KEY, ENV } from '@Constants/config';
import { useConnectIGLoginMutation } from './apiSlice';
import { FBWhite, LPLogoWName, Selfie2 } from '@assets/index';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '@Constants/routes';
import { displayToast } from '@Utils/toast';
import LocalStorage from '@Utils/storage';
import Loader from '@Components/Loader';
import { useLazyGetProfileQuery } from '@Pages/Profile/apiSlice';
var CryptoJS = require("crypto-js");

import { onLogout } from "@Utils/common";

declare global {
  interface Window {
    FB: any;
    fbAsyncInit: any;
  }
}

function InstagramLogin() {


  const navigate = useNavigate();
  const clientId = '1018531886387218';
  const redirectPath = '/connect/ig';
  const responseType = 'code';
  const scope = 'business_basic,business_manage_messages,business_manage_comments';

  // Construct the redirect URL dynamically using the current origin
  const redirectUri = `${window.location.origin}${redirectPath}`;


  const [connIG, { data: connIGData, error: connIGErr, isLoading: connIGLoading }] = useConnectIGLoginMutation();

  const [getProfile, { data: getProfileDataResponse }] = useLazyGetProfileQuery();

  const query = new URLSearchParams(useLocation().search);

  useEffect(() => {
    document.title = "LinkPlease - Instagram Login";

    const ig_code = query.get('code')

    if (ig_code == null) return;

    connIG({ code: ig_code, redirect_url: redirectUri })


  }, [])

  useEffect(() => {
    if (connIGData) {
      displayToast('success', 'Instagram Account connected')
      LocalStorage.setItem('igu', connIGData?.data?.username)
      LocalStorage.setItem('ppu', connIGData?.data?.profile_picture_url)
      if (connIGData.status) {
        getProfile({});
        navigate(`${ROUTES.IG_CONNECT_SUCCESS}`, { replace: true })
      }
    };
    if (connIGErr) {
      displayToast('error', connIGErr.data.message)
      console.log(connIGErr);
    }


  }, [connIGData, connIGErr])



  const handleClickLoginButton = () => {
    if (ENV == 'prod') {
      window.location.href = 'https://www.instagram.com/oauth/authorize?client_id=1018531886387218&redirect_uri=https://app.linkplease.co/connect/ig&response_type=code&scope=business_basic%2Cbusiness_manage_messages%2Cbusiness_manage_comments'
    }
    else if (ENV == 'stage') {
      window.location.href = 'https://www.instagram.com/oauth/authorize?client_id=1018531886387218&redirect_uri=https://liked-mutt-wrongly.ngrok-free.app/connect/ig&response_type=code&scope=business_basic%2Cbusiness_manage_messages%2Cbusiness_manage_comments'
    }
    else {
      window.location.href = 'https://www.instagram.com/oauth/authorize?client_id=1018531886387218&redirect_uri=https://fb81-103-215-237-98.ngrok-free.app/connect/ig?&response_type=code&scope=business_basic%2Cbusiness_manage_messages%2Cbusiness_manage_comments'
    }

    const authUrl = `https://www.instagram.com/oauth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&scope=${encodeURIComponent(scope)}`;

    // Redirect the user to the dynamically constructed URL
    window.location.href = authUrl;
  }


  const handleOnLogout = (e: any) => {
    onLogout()
    navigate(ROUTES.LOGIN)
  }
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-cover bg-center bg-no-repeat bg-fixed"
      style={styles.LOGIN_CONTAINER}>
      <div className="w-[90%] max-w-[400px] flex flex-col items-center bg-white px-1 py-8 md:p-8 rounded-2xl">
        <div className="mb-8">
          <img src={LPLogoWName} className="w-[250px]" alt="Linkplease Logo" />
        </div>

        <div className="text-center mb-4">
          <h1 className="text-[1.2rem] font-semibold">Connect Instagram Account ✨</h1>
          <p className="text-[#787781] text-sm mt-2">Only a few steps away to go Viral!</p>
        </div>

        <div className="bg-[#F9F9FB] rounded-xl p-4 mb-3">
          <div className="flex items-center justify-center gap-2 mb-2">
            <img
              src="https://img.icons8.com/?size=100&id=PvvcWRWxRKSR&format=png&color=000000"
              alt="check"
              className="w-8 h-8"
            />
            <h3 className="text-[#1877f2] font-semibold text-base">
              We're a Meta-verified business
            </h3>
          </div>
          <p className="text-[#787781] text-xs text-center mb-4">
            We only use official Instagram APIs and processes. Your Instagram account is secure, and you stay in full control.
          </p>
          <div className="space-y-3">
            <div className="flex items-start gap-2">
              <img src="https://img.icons8.com/ios-glyphs/30/40C057/verified-account--v1.png" alt="check" className="w-5 h-5" />
              <span className="text-[#787781] text-sm">Official Meta OAuth login</span>
            </div>
            <div className="flex items-start gap-2">
              <img src="https://img.icons8.com/ios-glyphs/30/40C057/verified-account--v1.png" alt="check" className="w-5 h-5" />
              <span className="text-[#787781] text-sm">Safe and Secure</span>
            </div>
            <div className="flex items-start gap-2">
              <img src="https://img.icons8.com/ios-glyphs/30/40C057/verified-account--v1.png" alt="check" className="w-5 h-5" />
              <span className="text-[#787781] text-sm">Used by 1000+ creators</span>
            </div>
          </div>
        </div>

        <div className="block md:hidden flex items-center justify-center gap-2 bg-yellow-50 border border-yellow-300 rounded-md p-3 text-sm text-yellow-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5 flex-shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
            />
          </svg>
          <span>
            Instagram may not connect on mobile, please use a <strong>desktop</strong> if possible.
          </span>
        </div>


        <button
          disabled={connIGLoading}
          onClick={handleClickLoginButton}
          className="w-full my-5 bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045] text-white py-3 rounded-lg font-medium hover:opacity-90 transition-colors disabled:opacity-50 flex items-center justify-center gap-3"
        >
          {connIGLoading ? (
            <span className="font-[500] text-white text-[16px]">Connecting Instagram</span>
          ) : (
            <>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C14.717 2 15.056 2.01 16.122 2.06C17.187 2.11 17.912 2.277 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8305 4.1779 21.224 4.78259 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.987 8.944 22 9.283 22 12C22 14.717 21.99 15.056 21.94 16.122C21.89 17.187 21.722 17.912 21.475 18.55C21.2247 19.2178 20.8311 19.8226 20.322 20.322C19.822 20.8303 19.2173 21.2238 18.55 21.475C17.913 21.722 17.187 21.89 16.122 21.94C15.056 21.987 14.717 22 12 22C9.283 22 8.944 21.99 7.878 21.94C6.813 21.89 6.088 21.722 5.45 21.475C4.78233 21.2245 4.17753 20.8309 3.678 20.322C3.16941 19.8222 2.77593 19.2175 2.525 18.55C2.277 17.913 2.11 17.187 2.06 16.122C2.013 15.056 2 14.717 2 12C2 9.283 2.01 8.944 2.06 7.878C2.11 6.812 2.277 6.088 2.525 5.45C2.77524 4.78218 3.1688 4.17732 3.678 3.678C4.17767 3.16923 4.78243 2.77573 5.45 2.525C6.088 2.277 6.812 2.11 7.878 2.06C8.944 2.013 9.283 2 12 2ZM12 7C10.6739 7 9.40215 7.52678 8.46447 8.46447C7.52678 9.40215 7 10.6739 7 12C7 13.3261 7.52678 14.5979 8.46447 15.5355C9.40215 16.4732 10.6739 17 12 17C13.3261 17 14.5979 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12C17 10.6739 16.4732 9.40215 15.5355 8.46447C14.5979 7.52678 13.3261 7 12 7ZM18.5 6.75C18.5 6.41848 18.3683 6.10054 18.1339 5.86612C17.8995 5.6317 17.5815 5.5 17.25 5.5C16.9185 5.5 16.6005 5.6317 16.3661 5.86612C16.1317 6.10054 16 6.41848 16 6.75C16 7.08152 16.1317 7.39946 16.3661 7.63388C16.6005 7.8683 16.9185 8 17.25 8C17.5815 8 17.8995 7.8683 18.1339 7.63388C18.3683 7.39946 18.5 7.08152 18.5 6.75ZM12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9Z" fill="white" />
              </svg>
              <span className="font-[500] text-white text-[16px]">Login with Instagram</span>
            </>
          )}
        </button>


        <div className="mt-4 text-center">
          <p className="text-[#787781] text-sm">
            By continuing, you agree to LinkPlease's{" "}<br />
            <a href="https://linkplease.co/terms-and-conditions/" target="_blank" className="text-[#7772FF] hover:underline">Terms of Service</a>
            {" "}and{" "}
            <a href="https://linkplease.co/privacy-policy/" target="_blank" className="text-[#7772FF] hover:underline">Privacy Policy</a>
          </p>
          <button onClick={handleOnLogout} className='mt-1 text-sm hover:'>Logout</button>
        </div>
      </div>
    </div>
  );
}

export default InstagramLogin;
